import React from "react"

import {Label} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import Spacing from "@irati/ui/src/Spacing"

const OverallLegend = () => {
  return (
    <svg width="42" height="8" viewBox="0 0 42 8" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 4.5H41H1Z" fill={theme.colors.primary2} />
      <path d="M1 4.5H41" stroke={theme.colors.primary2} strokeLinecap="square" />
      <rect x="17" width="8" height="8" fill={theme.colors.primary2} />
    </svg>
  )
}

const PerksLegend = () => {
  return (
    <svg width="42" height="8" viewBox="0 0 42 8" fill="none">
      <path d="M1 4.5H41" stroke={theme.colors.primary1} strokeLinecap="square" />
      <circle cx="21" cy="4" r="4" fill={theme.colors.primary1} />
    </svg>

  )
}

const CelebrationLegend = () => {
  return (
    <svg width="42" height="8" viewBox="0 0 42 8" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M21 0L25 8H17L21 0Z" fill={theme.colors.tertiary.p_400} />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 3.5H41H1Z" fill={theme.colors.tertiary.p_400} />
      <path d="M1 3.5H41" stroke={theme.colors.tertiary.p_400} strokeLinecap="square" />
    </svg>
  )
}

const WellnessLegend = () => {
  return (
    <svg width="42" height="8" viewBox="0 0 42 8" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 0L24.8042 2.76393L23.3511 7.23607H18.6489L17.1958 2.76393L21 0Z"
        fill={theme.colors.tertiary.i_400} />
      <path d="M1 4.5H41" stroke={theme.colors.tertiary.i_400} strokeLinecap="square" />
    </svg>
  )
}

const CultureHubLegend = () => {
  return (
    <svg width="42" height="8" viewBox="0 0 42 8" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 4.5H41H1Z" fill={theme.colors.secondary1} />
      <path d="M1 4.5H41" stroke={theme.colors.secondary1} strokeLinecap="square" />
      <rect x="19" width="4" height="8" fill={theme.colors.secondary1} />
    </svg>
  )
}

interface Props {}

const Legends: React.FC<Props> = () => {
  return (
    <Spacing marginTop={4} marginLeft={5}>
      <OverallLegend />
      <Label color={theme.colors.primary2} marginLeft={1} marginRight={3}>
        <FormattedMessage id="admin.components.dashboardGraph.legend.overall" />
      </Label>
      <PerksLegend />
      <Label color={theme.colors.primary1} marginLeft={1} marginRight={3}>
        <FormattedMessage id="admin.components.dashboardGraph.legend.perks" />
      </Label>
      <CelebrationLegend />
      <Label color={theme.colors.tertiary.p_400} marginLeft={1} marginRight={3}>
        <FormattedMessage id="admin.components.dashboardGraph.legend.celebration" />
      </Label>
      <WellnessLegend />
      <Label color={theme.colors.tertiary.i_400} marginLeft={1} marginRight={3}>
        <FormattedMessage id="admin.components.dashboardGraph.legend.wellness" />
      </Label>
      <CultureHubLegend />
      <Label color={theme.colors.secondary1} marginLeft={1}>
        <FormattedMessage id="admin.components.dashboardGraph.legend.cultureHub" />
      </Label>
    </Spacing>
  )
}

export default Legends
